import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/app-check";

export default function useComp() {
  function logout(tokenAuth) {
    this.$swal({
      title: "¿Seguro que deseas cerrar sesión?",
      icon: "question",
      width: "400px",
      showCancelButton: true,
      confirmButtonText: "Cerrar sesión",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-outline-secondary ml-1",
      },
      backdrop: true,
      buttonsStyling: false,
      allowOutsideClick: () => !this.$swal.isLoading(),
    }).then((result) => {
      this.$swal.close();

      if (result.isConfirmed) {
        firebase
          .auth()
          .signOut()
          .then(() => {
            // After successful sign out, update localStorage
            localStorage.setItem("userData", JSON.stringify({ tokenAuth }));
            this.$store.state.user = JSON.stringify({ tokenAuth });
            localStorage.removeItem("session");

            // Show success message
            this.$toast.success("Sesión cerrada exitosamente", {
              position: "top-right",
              max: 10,
            });

            // Redirect to login page
            this.$router.push({ name: "Signin" });
          })
          .catch((error) => {
            console.error("Error signing out: ", error);
            this.$toast.error("Error al cerrar sesión", {
              position: "top-right",
              max: 10,
            });
          });
      }
    });
  }
  return {
    logout,
  };
}
